import { ApiSmpGpt, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import produce from "immer";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useQueryGptAgentList } from "@/queries";

type Params = Parameters<typeof ApiSmpGpt.Agent.delete>[0];
type Response = Await<ReturnType<typeof ApiSmpGpt.Agent.delete>>;

export const useMutationGptAgentDelete = (
  options?: UseMutationOptions<Response, FailureApi, Params>,
) => {
  const queryClient = useQueryClient();

  return useMutation<Response, FailureApi, Params>(
    (id) => ApiSmpGpt.Agent.delete(id),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.setQueriesData<
          ReturnType<typeof useQueryGptAgentList>["data"]
        >(useQueryGptAgentList.KEY, (data) =>
          produce(data, (draft) => {
            draft?.pages.forEach((page) => {
              page.results = page.results.filter(
                (agent) => agent.id !== args[1],
              );
            });
          }),
        );

        options?.onSuccess?.(...args);
      },
    },
  );
};
